module.exports = "https://images.shiksha.ws/saassets/media/contactUsPhoneIcon.7d852e5c.svg";